<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row class="fill-height" justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Сводный отчет о полевой работе сотрудников
                </h3>
              </div>
            </v-card-title>
          </v-card>
          <v-card>
            <v-col cols="12">
              <div class="text-center">
                <v-dialog
                  v-model="loading"
                  persistent
                  width="300">
                  <v-card
                    color="primary"
                    dark>
                    <v-card-text>
                      Загружаются данные отчета
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
              <BaseControlElement :is-users-list="true"
                                  :lowest-date.sync="lowestDate"
                                  :highest-date.sync="highestDate"
                                  :selected-users.sync="selectedUsers"
                                  report-type="indicators"
                                  @submitSearch="submitSearch" />
            </v-col>

            <ReportTable :data="tableData"
                         :headers="headers"
                         :loading="loading"
                         :is-searchable="false"
                         :table-name="'Работа сотрудников('+lowestDate+' по '+highestDate+')'" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportTable from '../ReportTable'
import BaseControlElement from '../../base/BaseControlElement'
import {authHeader} from '../../../_helpers/auth-header'

export default {
  name: "ReportUsersWork",
  components: {
    ReportTable,
    BaseControlElement
  },
  props: {
    report: {
      type: String
    }
  },
  data () {
    return {
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      errorMessages: '',
      selectedUsers: [],
      loading: false,
      tableData: [],
      headers: [
        {text: '', value: '', align: 'left'},
        // {text: '', value: 'importance', align: 'd-none', class:['d-none']},
        {text: 'Сотрудник', value: 'name', align: 'left', sortable: true},
        {text: 'Количество выходов', value: 'amount', align: 'left', sortable: true},
        {text: 'Места выходов', value: 'places', align: 'left', sortable: true},
        {text: 'Количество часов', value: 'hours', align: 'left', sortable: true}
      ],
      loaded: false
    }
  },

  methods: {

    submitSearch () {
      this.loading = true
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }

      axios({
        url: this.$store.state.tableData.backend + '/report/users',
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          lowestDate: this.lowestDate,
          highestDate: this.highestDate,
          users: this.selectedUsers
        }

      }).then((response) => {
        this.loading = false
        this.tableData = response.data.data
        if (response.data.placesHours) {
          this.loaded = true
        }
      }).catch(() => {
        throw new Error(`You can't load the data`)
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportUsersWork.vue